<template>
    <v-container>
        <h2 class="py-2">Répartition des charges indirects secondaire sur le primaire</h2>
        <v-row class="d-flex justify-center">
            <v-col cols="10">
                <v-data-table
                    v-if="stockAssessment"
                    :headers="stockAssessment.analysisCenterHeaders"
                    :items="stockAssessment.analysisCenterTable"
                    class="table mt-2"
                    fixed-header
                    hide-default-footer
                    density="compact"
                >
                    <template v-slot:item="props">
                        <tr>
                            <template v-if="props.item.values && props.item.distributionKeys">
                                <td
                                    v-for="(header, i) in stockAssessment.analysisCenterHeaders"
                                    :key="i"
                                    :class="'text-' + header.align"
                                >
                                    <div
                                        v-if="header.value === 'title'"
                                        style="
                                            display: flex;
                                            align-items: top;
                                            justify-content: space-between;
                                        "
                                    >
                                        <span class="pr-6">{{
                                            props.item[header.value] || ""
                                        }}</span>
                                        <v-icon
                                            icon="$oss-edit"
                                            class="mt-1"
                                            size="small"
                                            color="primary"
                                            @click.stop="
                                                editTag(props.item.tagId, 'analysisCenterTable')
                                            "
                                        />
                                    </div>
                                    <span v-else-if="header.value === 'secondaryExpense'">{{
                                        newCommonFormatCurrency(
                                            props.item[header.value],
                                            undefined,
                                        ) || ""
                                    }}</span>
                                    <span v-else-if="header.value === 'directExpense'">{{
                                        "-"
                                    }}</span>
                                    <div v-else style="display: flex; justify-content: right">
                                        <v-chip size="x-small" dark class="mr-2">
                                            {{
                                                distributionFormat(
                                                    props.item.distributionKeys[header.value],
                                                )
                                            }}
                                        </v-chip>
                                        <span>
                                            {{
                                                newCommonFormatCurrency(
                                                    props.item.values[header.value],
                                                    undefined,
                                                ) || ""
                                            }}
                                        </span>
                                    </div>
                                </td>
                            </template>
                            <template v-else-if="props.item.values && !props.item.distributionKeys">
                                <td
                                    v-for="(header, i) in stockAssessment.analysisCenterHeaders"
                                    :key="i"
                                    :class="'text-' + header.align"
                                >
                                    <span v-if="header.value === 'title'">
                                        {{ props.item[header.value] || "" }}
                                    </span>
                                    <span v-else-if="header.value === 'directExpense'">{{
                                        newCommonFormatCurrency(
                                            props.item[header.value],
                                            undefined,
                                        ) || ""
                                    }}</span>
                                    <span v-else
                                        >{{
                                            newCommonFormatCurrency(
                                                props.item.values[header.value],
                                                undefined,
                                            ) || ""
                                        }}
                                    </span>
                                </td>
                            </template>
                            <template v-else>
                                <td
                                    v-for="(header, i) in stockAssessment.analysisCenterHeaders"
                                    :key="i"
                                    :class="'text-' + header.align"
                                >
                                    <span v-if="header.value === 'title'">
                                        <strong>Répartition secondaire</strong>
                                    </span>
                                </td>
                            </template>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <h2 class="py-2">Répartition des charges indirects sur les charges</h2>
        <v-row class="d-flex justify-center">
            <v-col cols="10">
                <v-data-table
                    v-if="stockAssessment"
                    :headers="stockAssessment.expenseHeaders"
                    :items="stockAssessment.expenseTable"
                    class="table mt-2"
                    hide-default-footer
                    :items-per-page="-1"
                    density="compact"
                >
                    <template #headers>
                        <tr>
                            <th
                                v-for="(header, index) in stockAssessment.expenseHeaders"
                                :key="index"
                                class="text-center"
                                style="border-bottom: none"
                            >
                                <div style="overflow-wrap: anywhere">
                                    <span style="font-size: 11pt">{{ header.title }}</span>
                                </div>
                                <div style="overflow-wrap: anywhere" v-if="header.symbol">
                                    <span style="font-size: 11pt">({{ header.symbol }})</span>
                                </div>
                            </th>
                        </tr>
                    </template>
                    <template v-slot:item="props">
                        <tr>
                            <td>
                                <div
                                    style="
                                        display: flex;
                                        align-items: top;
                                        justify-content: space-between;
                                    "
                                >
                                    <span class="pr-6">{{ props.item.title || "" }}</span>
                                    <v-icon
                                        icon="$oss-edit"
                                        class="mt-1"
                                        size="small"
                                        color="primary"
                                        @click.stop="editTag(props.item.tagId, 'expenseTable')"
                                    />
                                </div>
                            </td>
                            <td class="text-center">
                                <span v-if="props.item.type !== 'directExpense'">
                                    {{ newCommonFormatCurrency(props.item.value, undefined) }}
                                </span>
                            </td>
                            <td
                                v-for="(productDistribution, i) in props.item.products"
                                :key="i"
                                class="text-center"
                            >
                                <div style="display: flex; justify-content: center">
                                    <v-chip size="x-small" dark class="mr-2">
                                        {{ distributionFormat(productDistribution.percentage) }}
                                    </v-chip>
                                    <span>
                                        {{
                                            newCommonFormatCurrency(
                                                productDistribution.value,
                                                undefined,
                                            ) || ""
                                        }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <h2 class="py-2">Répartition des charges indirects sur les produits</h2>
        <v-row class="d-flex justify-center">
            <v-col cols="10">
                <v-data-table
                    v-if="stockAssessment"
                    :headers="stockAssessment.productHeaders"
                    :items="stockAssessment.productTable"
                    class="table mt-2"
                    hide-default-footer
                    :items-per-page="-1"
                    density="compact"
                >
                    <template #headers>
                        <tr>
                            <th
                                v-for="(header, index) in stockAssessment.productHeaders"
                                :key="index"
                                class="text-center"
                                style="border-bottom: none"
                            >
                                <div style="overflow-wrap: anywhere">
                                    <span style="font-size: 11pt">{{ header.title }}</span>
                                </div>
                                <div style="overflow-wrap: anywhere" v-if="header.symbol">
                                    <span style="font-size: 11pt">({{ header.symbol }})</span>
                                </div>
                            </th>
                        </tr>
                    </template>
                    <template v-slot:item="props">
                        <tr>
                            <td>
                                <div
                                    style="
                                        display: flex;
                                        align-items: top;
                                        justify-content: space-between;
                                    "
                                >
                                    <span class="pr-6">{{ props.item.title || "" }}</span>
                                    <v-icon
                                        icon="$oss-edit"
                                        class="mt-1"
                                        size="small"
                                        color="primary"
                                        @click.stop="editTag(props.item.tagId, 'productTable')"
                                    />
                                </div>
                            </td>
                            <td class="text-center">
                                {{ newCommonFormatCurrency(props.item.value, undefined) }}
                            </td>
                            <td
                                v-for="(productDistribution, i) in props.item.products"
                                :key="i"
                                class="text-center"
                            >
                                <div style="display: flex; justify-content: center">
                                    <v-chip size="x-small" dark class="mr-2">
                                        {{ distributionFormat(productDistribution.percentage) }}
                                    </v-chip>
                                    <span>
                                        {{
                                            newCommonFormatCurrency(
                                                productDistribution.value,
                                                undefined,
                                            ) || ""
                                        }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <TagEditionDialog
            v-model="showTagDialog"
            v-if="showTagDialog"
            :currentTag="currentTag"
            :companyId="companyId"
            :distribution="false"
            @upsertedTag="tagDistributionsChanged($event)"
            @cancel="resetTag()"
        >
        </TagEditionDialog>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";

import { Vue, Component, Prop, toNative } from "vue-facing-decorator";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { State2Way } from "@/decorators";
import { Apollo } from "../../decorators";
import _ from "lodash";

import { StockAssessment } from "../../../../backend/src/common/stock/stockAssessment";

import EVALUATE_STOCK from "../../graphql/stock/EvaluateStocks.gql";

import TagEditionDialog from "../tag/TagEditionDialog.vue";

@Component({
    components: {
        TagEditionDialog,
    },
})
export class StockAssessmentVue extends Vue {
    @Prop({ default: "" }) companyId: string;

    @State2Way("updateAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    selectedAccountingPeriod!: any;

    showTagDialog: boolean = false;

    secondaryTagName = "CI/Administration";
    directExpenseType = "directExpense";

    currentTag = null;

    tableReference = {
        id: "",
        table: "",
    };

    @Apollo({
        query() {
            return EVALUATE_STOCK;
        },
        variables() {
            return {
                companyId: this.companyId,
                startDate: this.selectedAccountingPeriod.start,
                endDate: this.selectedAccountingPeriod.end,
            };
        },
        skip() {
            return !this.companyId || !this.selectedAccountingPeriod;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.evaluateStocks) {
                    this.stockAssessment = new StockAssessment(
                        data.evaluateStocks.output.invoiceProducts,
                        data.evaluateStocks.output.balances,
                    );
                    this.stockAssessment.computeTables();
                } else {
                    this.stockAssessment = null;
                }
            }
        },
    })
    stockAssessment: StockAssessment = null;

    async editTag(tagId, table) {
        const tag = await this.$apollo.query({
            query: gql`
                query Tags($id: ID!) {
                    tags(where: { id: $id }) {
                        id
                        name
                        type
                        invoiceProductType
                        data
                    }
                }
            `,
            variables: {
                id: tagId,
            },
            fetchPolicy: "network-only",
        });
        if (tag.data?.tags?.length) {
            this.currentTag = _.cloneDeep(tag.data.tags[0]);
            this.showTagDialog = true;
            this.tableReference.id = tagId;
            this.tableReference.table = table;
        }
    }

    resetTag() {
        this.tableReference.id = "";
        this.tableReference.table = "";
        this.currentTag = null;
    }

    tagDistributionsChanged(data) {
        const changedRow = this.stockAssessment[this.tableReference.table].find(
            (row) => row.tagId === this.tableReference.id,
        );
        const stocks = data.data?.stocks ? data.data.stocks : {};

        if (this.tableReference.table === "analysisCenterTable") {
            for (const value in stocks) {
                changedRow.distributionKeys[value] = this.stockAssessment.toDecimal(stocks[value]);
            }
            this.onDistributionKeyChanged();
            this.updateExpenseAndProductTables();
        } else {
            this.stockAssessment.onPercentageChanged(changedRow, stocks);
        }
        this.showTagDialog = false;
        this.currentTag = null;
        this.tableReference.id = "";
        this.tableReference.table = "";
    }

    updateExpenseAndProductTables() {
        this.stockAssessment.updateExpenseAndProductTables();
    }

    onDistributionKeyChanged() {
        this.stockAssessment.onDistributionKeyChanged();
    }

    onPercentageChanged(row, productDistribution) {
        this.stockAssessment.onPercentageChanged(row, productDistribution);
    }

    distributionFormat(distribution) {
        const percentage = distribution ? distribution * 100 : 0;
        return percentage + "%";
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }
}

export default toNative(StockAssessmentVue);
</script>
